export default __webpack_public_path__ + "static/media/custom-development.b059677c.png";